import React, { useState } from 'react';
import { StepBand, ActiveIcon, StepNumber } from './styles';

const Title = (props) => {
    const { active, name, finished } = props;
    return (
        <>
            <StepBand active={active || finished} />
            <ActiveIcon type="caret-right" active={active} />          
            <StepNumber active={active}>
                {name}
            </StepNumber>
        </>
    );
}

export default Title;